'use client';
/** @jsxImportSource @emotion/react */

import type { ToolbarProps } from '@mui/material/Toolbar';

import MuiToolbar from '@mui/material/Toolbar';

export type { ToolbarProps };
export const Toolbar = MuiToolbar;
